<template>
  <v-container fluid class="darkbg" style="background: #FAFAF7">
    <!-- Subscription Detail Page/Dialog -->
    <v-row>
      <!-- Subscription Details -->
      <v-col>
        <div class="display-1 font-weight-bold">
        Subscription Details
        <hr style="border-color: primary;"/>
        </div>
        <span class="title ml-3 mr-5">Product:</span> {{subscription.product_name}}<br/>
        <span class="title ml-3 mr-5">Amount:</span> {{subscription.plan_amount}},00 €/{{subscription.plan_interval[0]}}<br/>
        <span class="title ml-3 mr-5">Started at:</span> {{moment(subscription.start_date).format('YYYY-MM-DD')}}<br/>
        <span class="title ml-3 mr-5">Status:</span>
          <v-chip
            color="warning" class="text-center" small label
            v-if="['active', 'trialing'].includes(subscription.status) && subscription.cancel_at != null"
            >{{subscription.status}}</v-chip>
          <v-chip
            color="success" class="text-center" small label
            v-else-if='subscription.status == "active"'
            >{{subscription.status}}</v-chip>
          <v-chip
            color="warning" class="text-center" small label
            v-else-if='subscription.status == "trialing"'
            >{{subscription.status}}</v-chip>
          <v-chip
            color="error" class="text-center" small label
            v-else
            >{{subscription.status}}</v-chip>
          <br/>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="display-1 font-weight-bold">
        Service account & licences
        <hr style="border-color: primary;"/>
        </div>
        <v-simple-table class="darkbg">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Product</th>
                <th class="text-left">Username</th>
                <th class="text-left">Token</th>
                <th class="text-left">Password</th>
                <th class="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in subscription.patrowlhears_accounts"
                :key="item.id"
              >
                <td><v-btn small href="https://hears.patrowl.io">PatrowlHears >></v-btn></td>
                <td>{{ item.username }}</td>
                <td>
                  {{ item.auth_token }}
                  <v-icon
                    title="Renew token"
                    color="primary" class="text-center" label
                    @click="renewPatrowlhearsToken(item.hears_id)"
                    >mdi-cached</v-icon>
                  <!-- <v-icon
                    title="Delete token"
                    color="red" class="text-center" label
                    @click="deletePatrowlhearsToken(item.hears_id)"
                    >mdi-close</v-icon>
                </td> -->
                <td>
                  renew
                  <v-icon
                    title="Renew password"
                    color="primary" class="text-center" label
                    @click="renewPatrowlhearsPassword(item.hears_id)"
                    >mdi-cached</v-icon>
                </td>
                <td>
                  <v-chip
                    title="Active"
                    color="success" class="text-center" small label
                    v-if="item.is_active"
                    >ok</v-chip>
                  <v-chip
                    title="Disabled"
                    color="error" class="text-center" small label
                    v-else
                    >disabled</v-chip>
                </td>

              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <!-- Invoices -->
    <v-row>
      <v-col>
        <div class="display-1 font-weight-bold">
        Invoices
        <hr style="border-color: primary;"/>
        </div>

        <v-data-table
          :headers="subscription_invoices_headers"
          :items="subscription_invoices"
          :options.sync="subscription_invoices_options"
          :server-items-length="subscription_invoices_total"
          :items-per-page="5"
          :footer-props="{
            'items-per-page-options': subscription_invoices_rowsPerPageItems
          }"
          :loading="subscription_invoices_loading"
          class="elevation-4lightbg"
          item-key="id"
          multi-sort
        >

        <!-- Amout -->
        <template v-slot:item.amount_paid="{ item }">
          {{item.amount_paid}}€
        </template>

        <!-- PDF -->
        <template v-slot:item.invoice_pdf="{ item }">
          <v-btn :href="item.invoice_pdf" small color="primary"><v-icon
            title="Download invoice as PDF file"
            class="mdi mdi-download"
            color="darkbg"
          ></v-icon>PDF</v-btn>
        </template>

        <!-- status -->
        <template v-slot:item.paid="{ item }">
          <v-chip
            v-if="item.paid == true"
            color="success" class="text-center" small label>paid</v-chip>
          <v-chip
            v-else
            color="error" class="text-center" small label>error</v-chip>
        </template>

        <!-- Created -->
        <template v-slot:item.created="{ item }">
          <span v-if='item.created' :title="moment(item.created).format('YYYY-MM-DD, hh:mm:ss')">{{moment(item.created).format('YYYY-MM-DD')}}</span>
        </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-snackbar v-model="snack" :timeout="snackTimeout" :color="snackColor" dense>
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-container>
</template>

<script>
import Products from '@/common/products';
// import moment from 'moment';

export default {
  name: "SubscriptionDetails",
  mixins: [Products],
  props: [
    'subscription_id'
  ],
  data: () => ({
    user_profile: {
      username: '',
      email: '',
      last_login: '',
      first_name: '',
      last_name: '',
      company: '',
      phone: '',
    },
    show_password: false,
    new_password: '',
    subscription: {
      status: '',
      product_name: '',
      plan_interval: '',
      start_date: '',
      product_features: {},
      patrowlhears_accounts: [],
    },
    subscription_invoices: [],
    subscription_invoices_total: 0,
    subscription_invoices_loading: false,
    subscription_invoices_limit: 5,
    subscription_invoices_options: {},
    subscription_invoices_headers: [
      { text: 'Number', value: 'number' },
      { text: 'Date', value: 'created' },
      { text: 'Amount', value: 'amount_paid' },
      { text: 'Status', value: 'paid' },
      { text: 'Download', value: 'invoice_pdf', sortable: false },
    ],
    subscription_invoices_rowsPerPageItems: [5, 10, 20, 50, 100],
    snack: false,
    snackColor: '',
    snackText: '',
    snackTimeout: 3000,
    loading: false,
  }),
  mounted() {
    this.getSubscriptionDetails();
    this.subscription_invoices_options.page = 1;
  },
  watch: {
    subscription_id: {
      handler() {
        this.getSubscriptionDetails();
        this.getInvoicesFromAPI();
      },
      deep: true
    },
    subscription_invoices_options: {
      handler() {
        this.getInvoicesFromAPI();
      },
      deep: true
    }
  },
  methods: {
    getSubscriptionDetails(){
      this.$api.get('/api/auth/subscriptions/details/'+this.subscription_id).then(res => {
        if (res && res.status === 200) {
          this.subscription = res.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getInvoicesFromAPI(){
      this.subscription_invoices_loading = true;

      return new Promise(resolve => {
        const {
          sortBy,
          sortDesc,
          page,
          itemsPerPage
        } = this.subscription_invoices_options;

        this.subscription_invoices_limit = itemsPerPage;
        let items = this.getInvoices(page, this.subscription_invoices_limit, sortBy, sortDesc);

        setTimeout(() => {
          resolve({
            items
          });
        }, 300);
        this.subscription_invoices_loading = false;
      });
    },
    getInvoices(page, itemsPerPage, sortBy, sortDesc){
      let sorted_by = '';
      if (sortBy.length > 0) {
        if (sortDesc[0] === true) {
          sorted_by = 'sorted_by=-' + sortBy;
        } else {
          sorted_by = 'sorted_by=' + sortBy;
        }
      }

      this.$api.get('/api/auth/subscriptions/invoices/list?limit='+itemsPerPage+'&page='+page+'&'+sorted_by+'&subscription_id='+this.subscription_id).then(res => {
        if (res && res.status === 200) {
          this.subscription_invoices = res.data.results;
          this.subscription_invoices_total = res.data.count;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    renewPatrowlhearsToken(patrowlhears_user_id){
      this.snack = true;
      this.snackColor = 'grey';
      this.snackText = 'Processing...';
      this.$api.get('/api/auth/patrowlhears/user/'+patrowlhears_user_id+'/token/renew').then(res => {
        if (res && res.status === 200 && res.data.status == 'success') {
          this.getSubscriptionDetails();
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Subscription successfully updated';
        } else {
          this.snack = true;
          this.snackColor = 'error';
          if ('reason' in res.data) {
            this.snackText = 'Error: '+res.data.reason;
          } else {
            this.snackText = 'Unable to update user\'s subscription';
          }
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to update user\'s subscription';
      });
    },
    // deletePatrowlhearsToken(patrowlhears_user_id){
    //   this.snack = true;
    //   this.snackColor = 'grey';
    //   this.snackText = 'Processing...';
    //   this.$api.get('/api/auth/patrowlhears/user/'+patrowlhears_user_id+'/token/delete').then(res => {
    //     if (res && res.status === 200 && res.data.status == 'success') {
    //       this.subscription.token = '';
    //       this.snack = true;
    //       this.snackColor = 'success';
    //       this.snackText = 'Subscription successfully deleted';
    //     } else {
    //       this.snack = true;
    //       this.snackColor = 'error';
    //       if ('reason' in res.data) {
    //         this.snackText = 'Error: '+res.data.reason;
    //       } else {
    //         this.snackText = 'Unable to delete user\'s subscription';
    //       }
    //     }
    //   }).catch(() => {
    //     this.snack = true;
    //     this.snackColor = 'error';
    //     this.snackText = 'Unable to update user\'s subscription';
    //   });
    // },
    renewPatrowlhearsPassword(patrowlhears_user_id){
      this.snack = true;
      this.snackColor = 'grey';
      this.snackText = 'Processing...';
      this.$api.get('/api/auth/patrowlhears/user/'+patrowlhears_user_id+'/password/renew').then(res => {
        if (res && res.status === 200 && res.data.status == 'success') {
          this.snack = true;
          this.snackColor = 'success';
          this.snackText = 'Subscription successfully updated. New password: '+res.data.password;
          this.snackTimeout = 30000;
        } else {
          this.snack = true;
          this.snackColor = 'error';
          if ('reason' in res.data) {
            this.snackText = 'Error: '+res.data.reason;
          } else {
            this.snackText = 'Unable to update user\'s subscription';
          }
        }
      }).catch(() => {
        this.snack = true;
        this.snackColor = 'error';
        this.snackText = 'Unable to update user\'s subscription';
      });
    },
  },
};
</script>

<style>
</style>
